module.exports = __webpack_public_path__ + "media/images/landkit/icons/social/instagram-26b7d2db09f6db09fce98ce69f7790e5.svg";